import { useEffect } from 'react'
import { offerWalletPasskeyRestore } from 'lib/walletPasskeyRestoreOffer'

/** On load, offer a one-tap passkey restore when this browser lost its wallet keys. */
export default function WalletPasskeyRestoreListener() {
    useEffect(() => {
        offerWalletPasskeyRestore().catch(error => {
            console.warn('Wallet passkey restore check failed', error)
        })
    }, [])
    return null
}
